import OauthCallback from '~/features/scenarios/components/oauthCallback'

function OauthCallbackPage() {
  return <OauthCallback />
}

export default OauthCallbackPage
